import './ControlsPlayerLive.scss'

import { useState } from "react";

import LivePlayer from "./LivePlayer/LivePlayer";
import TimeShift from "./TimeShift/TimeShift";
import { get_day_epg } from "../../../../server/requests";

export default function ControlsPlayerLive({
    showArchive,
    btn_next_channel,
    btn_previous_channel,
    activeMedia,
    playPause,
    btn_play_pause,
    channels,
    fullScreen,
    btn_full_screen,
    currentTime,
    duration,
    change_handle_range,
    valueProgress,
    callBackArchiveEpg,
    channelFavourite,
    btn_add_remove_favourites,
    show_time_shift,
    timeshift,
    showErrorMessage,
    btn_forward,
    btn_back_forward,
    isGuest
}) {


    return (
        <>
            {timeshift ?
                <TimeShift
                    activeMedia={activeMedia}
                    btn_play_pause={btn_play_pause}
                    playPause={playPause}
                    showArchive={showArchive}
                    btn_full_screen={btn_full_screen}
                    fullScreen={fullScreen}
                    currentTime={currentTime}
                    duration={duration}
                    show_time_shift={show_time_shift}
                    change_handle_range={change_handle_range}
                    valueProgress={valueProgress}
                    btn_forward={btn_forward}
                    btn_back_forward={btn_back_forward}
                />
                :
                <LivePlayer
                    isGuest={isGuest}
                    showErrorMessage={showErrorMessage}
                    btn_add_remove_favourites={btn_add_remove_favourites}
                    channelFavourite={channelFavourite}
                    btn_previous_channel={btn_previous_channel}
                    btn_next_channel={btn_next_channel}
                    callBackArchiveEpg={callBackArchiveEpg}
                    activeMedia={activeMedia}
                    playPause={playPause}
                    btn_play_pause={btn_play_pause}
                    channels={channels}
                    fullScreen={fullScreen}
                    btn_full_screen={btn_full_screen}
                    show_time_shift={show_time_shift}
                />
            }
        </>
    )
}